module.exports = __webpack_public_path__ + "img/pp.5ce53e7.png";